import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from '../../components/Modal';
import PropTypes from 'prop-types';

function FormSeleccionarAbono(props) {
    const {
        periodoL
        
    } = props;
    const tipos = [
        {
            value: 'ABONO',
            label: 'ABONO A PROVEEDORES'
        },
        
    ];
    
    const [id, setId] = useState("");
    const [idTA, setIdTA] = useState("");

    const handleChangeTA = e => {
        setIdTA(e.target.value);
    }

    const handleChange = e => {
        setId(e.target.value);
    }
   
    const [estadoModal, cambiarEstadoModal] = useState(true);
    let ruta = window.location.href;
    let id_emp = ruta.split('/');

    return (
        <div className='container'>
            <Modal
                estado={estadoModal}
                cambiarEstado={cambiarEstadoModal}
                titulo="Seleccionar"
                botonCerrar="false"
            >
                <div className="form-floating mb-3">
                    <select className="form-select" id="tipo" name="tipo"
                      value={idTA} onChange={handleChangeTA} autoFocus >
                      <option selected>Seleccionar...</option>
                      {tipos.map(
                        tipo => <option key={tipo.value} value={tipo.value}
                        >{tipo.label}
                        </option>)
                      }
                    </select>
                    <label className='form-label' htmlFor="mes">Tipo de abono</label>
                </div>
                {periodoL && idTA != '' &&
                    <div className="form-floating">
                        <select className="form-select" id="periodo"
                            value={id} onChange={handleChange} >
                            <option selected>Seleccionar...</option>
                            {periodoL.map(mes =>
                                <option key={mes.value} value={mes.value}>{mes.label}</option>)
                            }

                        </select>
                        <label className='form-label' htmlfor="periodo">Periodo</label>
                    </div>
                }
                <br />
                <Contenido>
                    {periodoL.length > 0 &&
                        (id &&
                        <a
                            href={`/#/compras/${id_emp[5]}/abonos/${id}`}
                            className='btn mr-2 mb-3 btn-primary'
                        >
                            Seleccionar
                        </a>
                        )
                    }
                </Contenido>
            </Modal>
        </div>
    );

}
FormSeleccionarAbono.propTypes = {
    periodoL: PropTypes.string.isRequired,
    listaEs: PropTypes.string.isRequired
};

export default (FormSeleccionarAbono);

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;